import { render, staticRenderFns } from "./DbTableControl.vue?vue&type=template&id=ac2692e0&"
import script from "./DbTableControl.vue?vue&type=script&lang=js&"
export * from "./DbTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports